module.exports = __webpack_public_path__ + "static/img/Cartridges.ca0fb60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cartridges.jpg
// module id = bL4a
// module chunks = 1